var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistorySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_66913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9C1.5 12.7279 4.5 16.5 9 16.5C13.5 16.5 16.5 13.5 16.5 9C16.5 4.5 13.5 1.5 9 1.5C4.5 1.5 1.5 5.25 1.5 5.25M1.5 5.25V2.25M1.5 5.25H4.125M9 6V9L11.25 10.5",
    stroke: "#00FEAE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_66913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorySelected);
export default __webpack_public_path__ + "static/media/history-selected.06a255cc6febfb1365aee1eb13e4b785.svg";
export { ForwardRef as ReactComponent };